import { PageContent } from "@/components/layout/MainWindow";
import { PageHeader } from "@/components/layout/PageHeader";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/settings/_admin/_disabled/invoices/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-full flex-col gap-y-7">
      <PageHeader title="Fakturaer" />

      <PageContent></PageContent>
    </div>
  );
}
